import { ActionType } from '../../actions-types';
import { Action } from '../../actions/user/index';

interface listState {
  data: [] | any;
}

const initialState: listState = {
  data: []
};

const UserReducer = (
  state: listState = initialState,
  action: Action
): listState => {
  switch (action.type) {
    case ActionType.GET_USER_EMAIL:
      return {
        ...initialState,
        data: action.payload
      };
    default:
      return state;
  }
};

export default UserReducer;
